export const rolePermissionsMap = {
  super_admin: {
    canCreate: true,
    canEdit: true,
    canDelete: true,
    canDownload: true,

    canCreateReservation: true,
    canEditReservation: true,
    canCancelReservation: true,

    canClickPastDates: true,
    canClickFutureDates: true,
    canClickBlockedDates: true,
    canClickBookedDates: true,

    canBlockDate: true,
    canUnblockDate: true,
  },
  property_owner: {
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canDownload: false,

    canCreateReservation: false,
    canEditReservation: false,
    canCancelReservation: false,

    canClickPastDates: false,
    canClickFutureDates: false,
    canClickBlockedDates: false,
    canClickBookedDates: false,

    canBlockDate: false,
    canUnblockDate: false,
  },
  property_manager: {
    canCreate: true,
    canEdit: true,
    canDelete: true,
    canDownload: true,

    canCreateReservation: true,
    canEditReservation: true,
    canCancelReservation: true,

    canClickPastDates: true,
    canClickFutureDates: true,
    canClickBlockedDates: true,
    canClickBookedDates: true,

    canBlockDate: true,
    canUnblockDate: true,
  },
  cleaning: {
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canDownload: false,

    canCreateReservation: false,
    canEditReservation: false,
    canCancelReservation: false,

    canClickPastDates: false,
    canClickFutureDates: false,
    canClickBlockedDates: false,
    canClickBookedDates: false,

    canBlockDate: false,
    canUnblockDate: false,
  },
} as const;

export type Role = keyof typeof rolePermissionsMap;

export type RolePermissions = {
  // Acciones generales
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canDownload: boolean;

  // Acciones sobre reservas
  canCreateReservation: boolean;
  canEditReservation: boolean;
  canCancelReservation: boolean;

  // Clicks en calendario
  canClickPastDates: boolean;
  canClickFutureDates: boolean;
  canClickBlockedDates: boolean;
  canClickBookedDates: boolean;

  // Bloqueos manuales
  canBlockDate: boolean;
  canUnblockDate: boolean;
};
